import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { currencies } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import CurrenciesContent from '../../../components/Dashboard/Workspace/CurrenciesContent'
import { LanguageConsumer } from '../../../LanguageContext'
import { CurrencyProvider } from '../../../CurrencyContext'

const Currencies = () => {
  const intl = useIntl()

  return (
    <>
      <SEO
        title={intl.formatMessage({ id: 'Currencies.Page.Title' })}
        pathname={window.location.origin}
        titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
        image={currencies.image}
        description={intl.formatMessage({ id: 'Currencies.Page.Title' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true} />}
            {!!Object.keys(userData).length && (
              <>
                {!!userData.is_admin ? (
                  <CurrencyProvider handleNotificationCall={handleNotificationCall}>
                    <LanguageConsumer>
                      {({ locale }) => (
                        <Layout content={
                          <CurrenciesContent
                            handleNotificationCall={handleNotificationCall}
                            locale={locale}
                          />
                        }
                        />
                      )}
                    </LanguageConsumer>
                  </CurrencyProvider>
                ) : (
                  !userDataLoading && <Redirect to={NamedRoutes.home} />
                )}
              </>
            )}
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default Currencies
